import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  // =========================================================
  // DESKTOP DROPDOWNS
  // =========================================================

  const [infoOpenDesktop, setInfoOpenDesktop] = useState(false);
  const [movingOpenDesktop, setMovingOpenDesktop] = useState(false);
  const [cranesOpenDesktop, setCranesOpenDesktop] = useState(false);

  // =========================================================
  // MOBILE DROPDOWNS
  // =========================================================

  const [infoOpenMobile, setInfoOpenMobile] = useState(false);
  const [movingOpenMobile, setMovingOpenMobile] = useState(false);
  const [cranesOpenMobile, setCranesOpenMobile] = useState(false);

  // =========================================================
  // BODY SCROLL
  // =========================================================

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  // =========================================================
  // CLOSE MOBILE MENU
  // =========================================================

  const closeMobileMenu = () => {
    setMenuOpen(false);

    setInfoOpenMobile(false);
    setMovingOpenMobile(false);
    setCranesOpenMobile(false);
  };

  return (
    <>
      {/* =========================================================
          HEADER
      ========================================================= */}

      <header className={`header ${menuOpen ? "menu-open" : ""}`}>

        {/* =====================================================
            LOGO
        ===================================================== */}

        <div className="logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img
              src="/logo.png"
              alt="ש.מ הובלות ומנופים"
            />
          </Link>
        </div>


        {/* =====================================================
            DESKTOP NAV
        ===================================================== */}

        <nav className="nav desktop-nav">

          {/* בית */}

          <Link to="/">
            בית
          </Link>


          {/* ===================================================
              הובלות עם מנוף הרמה
          =================================================== */}

          <div
            className="dropdown"
            onMouseEnter={() => setMovingOpenDesktop(true)}
            onMouseLeave={() => setMovingOpenDesktop(false)}
          >

            <Link
              to="/Moving_with_a_lifting_crane/"
              className="drop-title"
            >
              הובלות עם מנוף הרמה
              <span className="dropdown-arrow">⌄</span>
            </Link>


            {movingOpenDesktop && (
              <div className="dropdown-menu">

                <Link to="/Transportation_of_building_materials">
                  הובלת חומרי בניין
                </Link>

                <Link to="/Transporting_wood">
                  הובלת עצים
                </Link>

                <Link to="/Transporting_heavy_equipment">
                  הובלת ציוד כבד
                </Link>

                <Link to="/Container_Transportation">
                  הובלת מכולות
                </Link>

            

                <Link to="/Transportation_of_industrial_and_heavy_generators">
                  הובלת גנרטורים תעשייתיים 
                </Link>

              </div>
            )}

          </div>


          {/* ===================================================
              השכרת מנופים
          =================================================== */}

          <div
            className="dropdown"
            onMouseEnter={() => setCranesOpenDesktop(true)}
            onMouseLeave={() => setCranesOpenDesktop(false)}
          >

            <Link
              to="/Crane_Rental/"
              className="drop-title"
            >
              השכרת מנופים
              <span className="dropdown-arrow">⌄</span>
            </Link>


            {cranesOpenDesktop && (
              <div className="dropdown-menu">

                <Link to="/Basket_crane_rental/">
                  השכרת מנוף סל
                </Link>

                <Link to="/Crane_Rental1/">
                  השכרת מנוף זרוע
                </Link>

                <Link to="/Hourly_Lifting_Basket_Rental/">
                  השכרת סל הרמה לפי שעה
                </Link>

                <Link to="/Renting_a_basket_crane_for_lifting_a_person/">
                  השכרת מנוף סל להרמת אדם
                </Link>

              </div>
            )}

          </div>


          {/* עבודות מנוף */}

          <Link to="/Crane_work_throughout_the_country">
            עבודות מנוף בכל הארץ 
          </Link>
   <Link to="/Lifting_crane_in_Petah_Tikva">
                מנוף הרמה בפתח תקווה  
          </Link>

          {/* גלריה */}

          <Link to="/WorksGallery">
            גלריית עבודות
          </Link>


          {/* אודות */}

          <Link to="/About">
            אודות
          </Link>


          {/* צור קשר */}

          <Link to="/ContactSection2">
            צור קשר
          </Link>

        </nav>


        {/* =========================================================
            LEFT SECTION
        ========================================================= */}

        <div className="left-section">

          {/* השאירו פרטים */}

          <Link
            to="/ContactSection2"
            className="cta-btn"
          >
            השאירו פרטים
          </Link>


          {/* טלפון */}

          <a
            href="tel:0557711773"
            className="contact"
          >

            <span
              className="contact-icon"
              aria-hidden="true"
            >
              ☎
            </span>

            <div className="contact-text">

              <span className="contact-title">
                לייעוץ וקבלת הצעת מחיר
              </span>

              <span className="contact-number">
                055-7711773
              </span>

            </div>

          </a>


          {/* המבורגר */}

          <button
            type="button"
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={
              menuOpen
                ? "סגירת תפריט"
                : "פתיחת תפריט"
            }
            aria-expanded={menuOpen}
          >
            {menuOpen ? "✕" : "☰"}
          </button>

        </div>

      </header>


      {/* =========================================================
          OVERLAY
      ========================================================= */}

      <div
        className={`overlay ${menuOpen ? "show" : ""}`}
        onClick={closeMobileMenu}
      />


      {/* =========================================================
          MOBILE MENU
      ========================================================= */}

      <div
        className={`mobile-menu ${menuOpen ? "open" : ""}`}
      >

        {/* סגירה */}

        <button
          type="button"
          className="close-btn"
          onClick={closeMobileMenu}
          aria-label="סגירת תפריט"
        >
          ✕
        </button>


        {/* =====================================================
            בית
        ===================================================== */}

        <Link
          to="/"
          onClick={closeMobileMenu}
        >
          בית
        </Link>

 
      

        


        {/* =====================================================
            הובלות עם מנוף הרמה
        ===================================================== */}

        <div className="mobile-dropdown">

          <button
            type="button"
            className="mobile-drop-title"
            onClick={() =>
              setMovingOpenMobile(!movingOpenMobile)
            }
          >

                   <Link
              to="/Moving_with_a_lifting_crane/"
              className="drop-title"
            >
              הובלות עם מנוף הרמה
            </Link>

            <span className="mobile-arrow">
              {movingOpenMobile ? "▲" : "▼"}
            </span>

          </button>


          {movingOpenMobile && (
            <div className="mobile-submenu">

              <Link
                to="/Transportation_of_building_materials"
                onClick={closeMobileMenu}
              >
                הובלת חומרי בניין
              </Link>

              <Link
                to="/Transporting_wood"
                onClick={closeMobileMenu}
              >
                הובלת עצים
              </Link>

              <Link
                to="/Transporting_heavy_equipment"
                onClick={closeMobileMenu}
              >
                הובלת ציוד כבד
              </Link>

              <Link
                to="/Container_Transportation"
                onClick={closeMobileMenu}
              >
                הובלת מכולות
              </Link>

       

              <Link
                to="/Transportation_of_industrial_and_heavy_generators"
                onClick={closeMobileMenu}
              >
                הובלת גנרטורים תעשייתיים 
              </Link>

            </div>
          )}

        </div>


        {/* =====================================================
            השכרת מנופים
        ===================================================== */}

        <div className="mobile-dropdown">

          <button
            type="button"
            className="mobile-drop-title"
            onClick={() =>
              setCranesOpenMobile(!cranesOpenMobile)
            }
          >

           <Link
              to="/Crane_Rental/"
              className="drop-title"
            >
              השכרת מנופים
            </Link>

            <span className="mobile-arrow">
              {cranesOpenMobile ? "▲" : "▼"}
            </span>

          </button>


          {cranesOpenMobile && (
            <div className="mobile-submenu">

              <Link
                to="/Basket_crane_rental/"
                onClick={closeMobileMenu}
              >
                השכרת מנוף סל
              </Link>

              <Link
                to="/Crane_Rental1/"
                onClick={closeMobileMenu}
              >
                השכרת מנוף זרוע
              </Link>

              <Link
                to="/Hourly_Lifting_Basket_Rental/"
                onClick={closeMobileMenu}
              >
                השכרת סל הרמה לפי שעה
              </Link>

              <Link
                to="/Renting_a_basket_crane_for_lifting_a_person/"
                onClick={closeMobileMenu}
              >
                השכרת מנוף סל להרמת אדם
              </Link>

            </div>
          )}

        </div>


        {/* =====================================================
            השירותים
        ===================================================== */}


        {/* =====================================================
            עבודות מנוף
        ===================================================== */}

        <Link
          to="/Crane_work_throughout_the_country"
          onClick={closeMobileMenu}
        >
          עבודות מנוף בכל הארץ
        </Link>

     <Link
          to="/Lifting_crane_in_Petah_Tikva"
          onClick={closeMobileMenu}
        >
                מנוף הרמה בפתח תקווה  
        </Link>



        {/* =====================================================
            גלריה
        ===================================================== */}

        <Link
          to="/WorksGallery"
          onClick={closeMobileMenu}
        >
          גלריית עבודות
        </Link>


        {/* =====================================================
            אודות
        ===================================================== */}

        <Link
          to="/About"
          onClick={closeMobileMenu}
        >
          אודות
        </Link>


        {/* =====================================================
            צור קשר
        ===================================================== */}

        <Link
          to="/ContactSection2"
          onClick={closeMobileMenu}
        >
          צור קשר
        </Link>


  
  

      </div>
    </>
  );
}
